export default {
  // Website varibles
  websiteVariables: null,

  // Navigation links
  navigationLinks: [],

  // Navigation drawer
  navDrawer: false,

  // User
  user: null,

  // Login
  userLoginError: "",
  loginSuccess: false,
  loginButtonLoading: false,

  // Register
  registerButtonLoading: false,
  userRegistrationError: "",
  accessJustification: "",

  // Password reset
  resetPasswordDialog: false,
  resetPasswordForm: false,

  // Visualisation section of the main graph
  colorScores: true,
  colorModel: true,

  axisMaxAuto: false,
  axisMax: 365,

  hideNoModel: false,

  modelGroupTab: 0,

  // Images are saved as base64 strings
  leftImageEncoded: "",
  rightImageEncoded: ""
};
